import { useContext } from 'react';

import BusinessToolAiContext from './business-tool-ai-context';

export const useBusinessToolAiContext = () => useContext(BusinessToolAiContext);
